import { Link } from "react-router-dom";
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import { useTranslation } from "react-i18next";
// import DropdownMenuHeader from "components/ProjectManagementComponents/Common/Header/DropdownMenuHeader";

const ReportListViewHeader = ({ refreshList = () => {} }) => {
  const { t } = useTranslation();
  const breadCrumbText = [{ title: t("Full Report") }];

  return (
    <div className="bg-white mt-3 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="ps-1">
          <BreadCrumb breadCrumbText={breadCrumbText} top={false} />
        </div>
        <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
          <Link
            onClick={refreshList}
            to="#"
            className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            title={t("Reload")}
          >
            <span className="material-symbols-outlined icon-md me-1">
              refresh
            </span>
            <span className="fw-semibold small">{t("Reload")}</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ReportListViewHeader;
